<template>
  <div class="not-found">
    <div class="content">
      <div class="smiley">☹️</div>
      <h1>404</h1>
      <p>Oops! Die Seite existiert nicht.</p>
      <router-link to="/" class="btn">Zur Startseite</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style scoped>
.not-found {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--secondary-dark);
  color: white;
  text-align: center;
}

.not-found .content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.not-found .smiley {
  font-size: 6rem;
  margin-bottom: 1rem;
  transition: transform 0.3s ease, color 0.3s ease;
  cursor: default;
}

/* Slight sad bounce animation */
@keyframes sadBounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px) rotate(-10deg);
  }
  60% {
    transform: translateY(-5px) rotate(5deg);
  }
}

.not-found .smiley:hover {
  animation: sadBounce 1s infinite;
  color: var(--accent);
}

.not-found .content h1 {
  font-size: 8rem;
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.not-found .content p {
  font-size: 2rem;
  margin-bottom: 2rem;
  color: var(--text-secondary);
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.not-found .btn {
  background: var(--accent);
  color: white;
  padding: 1rem 2rem;
  border-radius: 8px;
  text-decoration: none;
  font-weight: bold;
  transition: background-color 0.3s ease;
}

.not-found .btn:hover {
  background: var(--primary);
}
</style>
